$('.room-gallery__item').on('click', function (e) {
    let gallery = $(this).data('images');

    $.fancybox.open(gallery, {
        // loop: false
    });
});
